import React from "react"

import { Dropdown } from "antd"
import { useTranslation } from "react-i18next"

import { useExternalDemoMode } from "../../hooks/useExternalDemoMode"
import Icon from "../../Icon"
import Button from "../Button"

const defaultItems = [
  {
    key: "all",
    label: "Export all"
  },
  {
    key: "as_filtered",
    label: "Export as filtered"
  }
]

const ExportDropdown = ({
  loading,
  onExport,
  isAdmin,
  disabled,
  items = defaultItems,
  exportAsFiltered,
  iconButton = false,
  fullWidths = false,
  inHeader = false,
  height
}) => {
  const { t } = useTranslation()
  const externalDemoMode = useExternalDemoMode()

  const updatedItems = items.map((item) => ({
    ...item,
    disabled,
    "data-testid": `export-menu-item-${item.key}`
  }))

  if ((isAdmin || exportAsFiltered) && !externalDemoMode) {
    return (
      <Dropdown
        overlayClassName="custom-menu"
        getPopupContainer={() => document.getElementById("main-layout")}
        menu={{
          //items: items.map(item => ({...item, label: t(item.label)})),
          items: updatedItems,
          onClick: ({ key }) => onExport(key)
        }}
        trigger={["click"]}
        placement="bottomLeft"
      >
        <div className="edit-columns-trigger" onClick={(e) => e.stopPropagation()}>
          <Button
            className={`flex center ${iconButton && !inHeader && "isMobile"}`}
            loading={loading}
            style={{
              height: height
            }}
            icon={<Icon type="file_download" style={{ fontSize: 20, transform: "rotate(0deg)" }} />}
            data-testid="export-button"
          >
            {!iconButton && !inHeader && t("Export")}
          </Button>
        </div>
      </Dropdown>
    )
  } else {
    return (
      <Button
        icon={<Icon type="file_download" style={{ fontSize: 20 }} />}
        className={`flex center ${iconButton && !inHeader && "isMobile"}`}
        loading={loading}
        disabled={disabled || externalDemoMode}
        onClick={(event) => {
          event.stopPropagation()
          onExport("all")
        }}
        style={{
          width: fullWidths && "100%",
          height: height,
          marginBottom: fullWidths && 12
        }}
        data-testid="export-button"
      >
        {!iconButton && !inHeader && t("Export")}
      </Button>
    )
  }
}

export default React.memo(ExportDropdown)
